import { Field } from "../FieldService";
import { Argument, Expression, Functional, ofValue } from "./Argument";

export default class ExpressionParser {
	private readonly infoFields: Field[];

	constructor(infoFields: Field[]) {
		this.infoFields = infoFields;
	}

	public parse(expression: string): string {
		try {
			const tokens = this.tokenize(expression);
			const evaluated = this.evaluate(tokens);
			return this.calculate(evaluated);
		} catch (all) {
			console.warn(all);
			return expression;
		}
	}

	private tokenize(expression: string): Array<Argument> {
		const args: Array<Argument> = [];

		let token = "";
		for (let index = 0; index < expression.length; ++index) {
			const char = expression[index];

			if (char === '"') {
				const tokens = this.readUntilFound(
					expression.substring(index + 1),
					char
				);
				index += tokens.length + 1;
				token += tokens;
			} else if (char === "(") {
				const func = token;
				const [read, funcArgs] = this.readArguments(
					expression.substring(index + 1)
				);
				args.push(new Functional(func, funcArgs));
				token = "";

				index += read;
			} else if (char === " " || char === ",") {
				if (token.length > 0) {
					args.push(ofValue(token));
					token = "";
				}
			} else {
				token += char;
			}
		}

		if (token.length > 0) {
			args.push(ofValue(token));
		}

		return args;
	}

	private readUntilFound(expression: string, character: string): string {
		// TODO: allow character to be escaped.
		let tokens = "";
		for (const char of expression) {
			if (char === character) {
				return tokens;
			}

			tokens += char;
		}

		throw new Error(`Invalid expression. Missing closing ${character}`);
	}

	private readArguments(expression: string): [number, Array<Argument>] {
		const args: Array<Argument> = [];

		let token = "";
		for (let index = 0; index < expression.length; ++index) {
			const char = expression[index];

			if (char === ",") {
				if (token.length > 0) {
					args.push(ofValue(token));
					token = "";
				}
			} else if (char === '"') {
				const tokens = this.readUntilFound(
					expression.substring(index + 1),
					'"'
				);
				index += tokens.length + 1;
				token += tokens;
			} else if (char === "(") {
				const func = token;
				const [read, funcArgs] = this.readArguments(
					expression.substring(index + 1)
				);
				args.push(new Functional(func, funcArgs));
				token = "";

				index += read;
			} else if (char === ")") {
				if (token.length > 0) {
					args.push(ofValue(token));
				}

				return [index + 1, args];
			} else if (char !== " ") {
				token += char;
			}
		}

		return [expression.length, args];
	}

	private evaluate(tokens: Array<Argument>): Array<Argument> {
		const evaluatedTokens: Array<Argument> = [];
		for (const token of tokens) {
			if (token instanceof Expression) {
				evaluatedTokens.push(token.resolve(this.infoFields));
			} else if (token instanceof Functional) {
				evaluatedTokens.push(token.execute(this.infoFields));
			} else {
				evaluatedTokens.push(token);
			}
		}

		return evaluatedTokens;
	}

	private calculate(tokens: Array<Argument>): string {
		if (tokens.length > 1) {
			throw new Error(
				"Invalid expression: should evaluate to single value."
			);
		}

		return tokens[0].toString();
	}
}
